<template>
    <div class="autocomplete">
        <input
                type="text"
                v-model="search"
                @focus="loadData"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
                @keydown.enter="onEnter"
                class="form-control"
                readonly
                />
        <ul id="autocomplete-results"  v-show="results.length > 0" class="autocomplete-results">
            <li class="loading" v-if="isLoading">
                Loading results...
            </li>
            <li v-else
                v-for="(result, i) in results"
                :key="i"
                class="autocomplete-result"
                :class="{ 'is-active': i === arrowCounter }"
                    >
                <b-form-checkbox
                        v-model="result.status"
                        @change="setResult(result)"
                        >
                    {{ result.name }}
                </b-form-checkbox>
            </li>
        </ul>
    </div>
</template>

<script>

    import Axios from 'axios';

    export default {
        name: 'statusForm',
                data() {
            return {
                results: [],
                selects: [],
                search: '',
                isLoading: false,
                arrowCounter: -1
            };
        },
        props: {
            items: {
                type: Array,
                required:   false,
                default:    []
            },

            title: {
                type:       String,
                required:   false,
                default:    ''
            }
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);
            this.search = this.title;
        },

        destroyed() {
            document.removeEventListener('click', this.handleClickOutside)
        },

        methods: {
            loadData(){
                let _this = this;
                Axios
                   .get(_this.prefix_url + '/api/opp?ts='+Date.now()+'&type=status')
                   .then(response => {
                        this.results = response.data.rules;
                        _this.results.forEach(function (data) {
                            var obj = _this.items.find(item => item.id === data.id);
                            if (typeof obj !== 'undefined') data.status = true;else data.status = false;
                        });
                });
            },

            setTitle(){
                let s = [];
                let _this = this;
                this.results.forEach(function (data) {
                    if (data.status) s.push(data.name);
                });
                this.search = s.join(', ');
            },

            setResult(result) {
                this.setTitle();
                if (result.status) {
                    this.$emit('addProduct', result);
                } else {
                    this.$emit('delProduct', result);
                }
            },

            onChange() {
                this.$emit('input', this.search);
            },

            handleClickOutside(event) {
                if (!this.$el.contains(event.target)) {
                    this.results = [];
                    this.arrowCounter = -1;
                }
            },

            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },

            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },

            onEnter() {
                this.results = [];
                this.arrowCounter = -1;
            },

            sort() {
                this.results.sort(function (a, b) {
                    let c1 = 0;
                    let c2 = 0;

                    if (a.children === false) c1=0;else c1=a.children.length;
                    if (b.children === false) c2=0;else c2=b.children.length;

                    if (c1 < c2) return 1;
                    else if (c1 > c2) return -1;
                    else return 0;
                });
            }
        },

        computed : {
            prefix_url:function () { return process.env.VUE_APP_PREFIX_URL }
        }
    }
</script>

<style>
    .autocomplete {
        position: relative;
        width: 100%;
    }

    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        height: 220px;
        overflow: auto;
        position: absolute;
        background-color: white;
        width: 100%;
        z-index: 99;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    }

    .autocomplete-result.is-active,
    .autocomplete-result:hover {
        background-color: #4AAE9B;
        color: white;
    }
</style>
